<script>
  import ShareAsk from '$lib/client/asks/share.svelte';
  import PlayButton from '$lib/client/shared/play-button.svelte';
  import Paper, { Title, Content } from '@smui/paper';
  import { DateTime } from 'luxon';
  import { createEventDispatcher } from 'svelte';

  export let ask;

  const track = ask.context;

  const dispatch = createEventDispatcher();
  const nextUp = track.next_on
               ? DateTime.fromMillis(track.next_on.scheduled_at).toFormat('T ZZZZ')
    : undefined;
</script>

{#if ask.status === 'completed'}
  <Title class="t-uppercase">{ask.title}</Title>
  <Content>
    Thanks for sharing {track.title}, you're amazing!
    {#if track.next_on?.scheduled_at}
      It's next on at {nextUp} on the
      <a href={`/music/${track.next_on.channel.slug || ''}`} class="link"
        >{track.next_on.channel.name}</a
      > channel. Don't forget to rate!
    {:else}
      {track.title} is next on tomorrow. Check back and don't forget to rate!
    {/if}
  </Content>
{:else}
  <ShareAsk
    {ask}
    on:completed={(e) => {
      dispatch('completed');
    }}
  >
    One of your favourite tracks, <span class="t-uppercase">{track.title}</span> by
    <span class="t-titlecase"
      ><a href={`/artists/${track.artist.slug}`} class="link">{track.artist.name}</a></span
    >
    {#if track.next_on?.scheduled_at}
      is on today at {nextUp} on the
      <a href={`/music/${track.next_on.channel.slug || ''}`} class="link"
        >{track.next_on.channel.name}</a
                                     > channel. <p>Can you share with your friends so we can all listen together?</p>
    {:else}
      is next on tomorrow. Listen and rate to boost for tomorrow's playlist!
      <p>
        Can you share with your friends to help others discover {track.artist.name} get more plays?
      </p>
    {/if}

    <div slot="actions">
      <PlayButton {track} />
    </div>
  </ShareAsk>
{/if}
